const year = new Date().getFullYear();
export const years = Array.from(new Array(30), (val, index) => year - index);
